import { api, ApiResponse } from '@/api/api';
import { INTERVIEW_URLS } from '@/api/url';
import { isAxiosError } from 'axios';

/**
 * Fetches a list of unscheduled candidates from the API
 * @returns Promise containing the API response with client data
 * @throws Error if the API request fails with a non-Axios error
 */
export const apiGetUnscheduledCandidates = async (): Promise<ApiResponse<Client[]>> => {
  try {
    const response = await api.get<ApiResponse<Client[]>>(
      INTERVIEW_URLS.GET_UNSCHEDULED_CANDIDATES
    );
    return response.data;
  } catch (error: unknown) {
    if (isAxiosError(error)) {
      return (
        error.response?.data ?? {
          success: false,
          message: 'Failed to fetch unscheduled candidates',
          data: []
        }
      );
    }

    // Log unexpected errors for debugging
    console.error('Unexpected error in apiGetUnscheduledCandidates:', error);
    throw new Error('An unexpected error occurred while fetching unscheduled candidates');
  }
};
